import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { finalize, first } from 'rxjs/operators';
import { UtilsService } from 'src/app/core/service/utils.service';
import { BoardMainScreenService } from 'src/app/pages/projects/board/board-main-screen/board-main-screen.service';
import { BoardServiceService } from 'src/app/pages/projects/services/board-service.service';
import { ProjectSettingService } from 'src/app/pages/projects/services/project-setting.service';
import { SettingsPageService } from '../../settings-service/settings-page.service';

@Component({
  selector: 'app-column-modal',
  templateUrl: './column-modal.component.html',
  styleUrls: ['./column-modal.component.scss']
})
export class ColumnModalComponent implements OnInit {

  @ViewChild("modal") modal!: ElementRef;
  @Output() updateTable: EventEmitter<any> = new EventEmitter();

  projectId: number | null = null;
  modalTitle: string;

  columnForm!: FormGroup;
  submitted: boolean = false;
  modalRef: NgbModalRef;
  loading: boolean = true;
  types: any[];

  constructor(protected settingSrv: SettingsPageService,
    private boardMainScreen: BoardMainScreenService,
    protected projSettingSrv: ProjectSettingService,
    protected modalService: NgbModal,
    protected boardService: BoardServiceService,
    protected fb: FormBuilder,
    public translateService: TranslateService,
    protected utilSrv: UtilsService) {
  }

  ngOnInit(): void {
    this.setForm();
  }

  get formColumn() { return this.columnForm.controls; }

  setForm() {
    this.columnForm = this.fb.group({
      id: [0],
      name: ['', Validators.required],
      resolvedTasks: [false],
      color: [this.get_random_color(), Validators.required],
    });
  }

  openModal(type: string, data: any, projectId?: number) {
    this.loading = true;
    this.setForm();


    if (projectId) this.projectId = projectId;
    this.modalTitle = type === 'addColumn' ? 'SETTINGS.EVENT.ADDCOLUMN' : 'SETTINGS.EVENT.EDITCOLUMN';

    if (type === 'editColumn') this.fillForm(data);
    else this.loading = false;
    this.modalRef = this.modalService.open(this.modal, { centered: true, backdrop: 'static', keyboard: false });
  }

  fillForm(data: any) {
    this.columnForm.patchValue({ id: data.id, name: data.name, color: data.color, resolvedTasks: data.resolvedTasks });
    this.loading = false;
  }

  save() {

    this.submitted = true;
    if (this.columnForm.valid) {
      let data = { name: this.formColumn.name.value, color: this.formColumn.color.value, resolvedTasks: this.formColumn.resolvedTasks.value }
      if (this.formColumn.id.value == 0) {
        this.boardService.createColumn(this.projectId, data)
          .pipe(first(), finalize(() => {
            this.modalRef.close();
            this.updateTable.emit();
          }))
          .subscribe((response) => {
            this.settingSrv.registerConfigurations(data);
            this.utilSrv.notify('SETTINGS.CREATED', 'success');
            this.setForm();
            this.submitted = false;
            this.boardMainScreen.realoadTasks.next(true);
          }, (error: any) => {
            console.error('Save', error);
            this.utilSrv.notify('SETTINGS.ERROR', 'error');
          });
      } else {
        this.boardService.updateColumn(this.projectId, this.formColumn.id.value, data).pipe(first(), finalize(() => {
          this.modalRef.close();
          this.updateTable.emit();
        })).subscribe((response) => {
          this.settingSrv.updateConfiguration(data, this.formColumn.id.value);
          this.utilSrv.notify('SETTINGS.UPDATED', 'success');
          this.setForm();
          this.submitted = false;
          this.boardMainScreen.realoadTasks.next(true);
        }, (error: any) => {
          console.error('Save', error);
          this.utilSrv.notify('SETTINGS.ERROR', 'error');
        });
      }
    }
  }

  get_random_color() {
    var color = "";
    for (var i = 0; i < 3; i++) {
      var sub = Math.floor(Math.random() * 256).toString(16);
      color += (sub.length == 1 ? "0" + sub : sub);
    }
    return "#" + color;
  }

  closeModal() {
    this.submitted = false;
    this.columnForm.reset();
    this.modalRef.close();
  }

}
